module.exports = __webpack_public_path__ + "static/images/threeDots.4351701adc423a58bf0cc464e08ed597.svg";